import React from 'react';
import PageTitle from '../../../Components/PageTitle.js';
import Grid from '@mui/material/Grid';
import AuthorListItem from './Components/AuthorListItem.js';
import Authors from '../../../Components/Queries/Authors.js';
import { useTranslation } from 'react-i18next';
import StoreSectionContainer from '../../../Components/Store/StoreSectionContainer.js';

const AuthorsPage = () => {
  const { t } = useTranslation();

  const translatedTitle = t('our-authors');

  return (
    <StoreSectionContainer
      heading={translatedTitle}
    >
      <PageTitle title={translatedTitle} />
      <Authors>
        {
          data =>
            <Grid
              container
              direction='row'
              justifyContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              {
                data.map((author, index) => author.products.length > 0 &&
                  <AuthorListItem key={index} author={author} />
                )
              }
            </Grid>
        }
      </Authors>
    </StoreSectionContainer>
  );
};

export default AuthorsPage;
